import React, { useEffect, useState } from 'react';
import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking/useNinja';
import ArrowRight from '@nexus/lib-react/dist/core/Icon/icons/default/ArrowRight';
import { getConfig } from '@olxeu-a2b/delivery-utils/src/extras/getConfig';
import getClaimAttachment from '@olxeu-a2b/delivery-utils/src/bindings/returns/helpers/getClaimAttachment';
import { trackingKeys } from '@olxeu-a2b/delivery-utils/src/tracking';
import S from './style/ReturnsReport';
import { useI18n } from '../../../../i18n';
import { USER_TYPE } from '../../constants';

interface ReturnsReportProps {
  orderId: string;
  fileName: string;
  text: string;
  attachmentsCount: number;
  isSeller: boolean;
  trackingExtras: {
    seller_type: USER_TYPE;
    ad_id: string;
    seller_id: string;
    touch_point_page: string;
  };
  isDesktop: boolean;
}

const ReturnsReport = ({
  orderId,
  fileName,
  text,
  attachmentsCount,
  isSeller,
  trackingExtras,
  isDesktop,
}: ReturnsReportProps) => {
  const i18n = useI18n();
  const [file, setFile] = useState('');
  const config = getConfig();
  const trackEvent = useTrackEvent();

  useEffect(() => {
    if (fileName) {
      getClaimAttachment(orderId, fileName).then(blob => {
        const reader = new window.FileReader();
        reader.readAsDataURL(blob);

        reader.onloadend = () => {
          setFile(reader.result.toString());
        };
      });
    }
  }, [orderId, fileName]);

  const handleReadReportClick = () => {
    trackEvent(trackingKeys.events.deliverySdReportReadClick, null, null, trackingExtras);

    const baseUrl = isDesktop ? config?.sites?.desktop?.url : config?.sites?.mweb?.url;
    window.location.href = `${baseUrl}/safedeal/report/details/${orderId}`;
  };

  return (
    <S.ReturnsReportBlock>
      <S.ReturnsReportTitle>
        {isSeller ? i18n('dlv_returns_buyer_report') : i18n('dlv_returns_your_report')}
      </S.ReturnsReportTitle>
      <S.ReturnsReportDataBlock>
        <S.ImageAndTextBlock>
          {file && (
            <S.ImageBlock>
              <img alt="" src={file} height={60} width={60} />
              <S.AttachmentsCountText>{attachmentsCount}</S.AttachmentsCountText>
            </S.ImageBlock>
          )}
          <S.ReturnsReportText>{text}</S.ReturnsReportText>
        </S.ImageAndTextBlock>
        <S.ArrowWrapper>
          <ArrowRight data-testid="arrowButton" onClick={handleReadReportClick} />
        </S.ArrowWrapper>
      </S.ReturnsReportDataBlock>
      <S.ActionButton data-testid="reportReadButton" onClick={handleReadReportClick}>
        {i18n('dlv_returns_read_report')}
      </S.ActionButton>
    </S.ReturnsReportBlock>
  );
};

export default ReturnsReport;
